import CustomSkinHelper from '@/pages/product/components/CustomSkin/helper';
// import ExtraBindServiceConfig from '@/components/ExtraBindService/data.config';

/** 判断是否是定制贴商品 */
export const isCustomProduct = (pid: number) => {
  // 不能直接加购产品列表（定制贴商品）
  const customProductIds = CustomSkinHelper.CustomSkinPidList;
  return customProductIds.includes(pid);
};

export const isX3X4 = (pid: number) => {
  return [19, 26].includes(pid);
};

/**
 * 商品名移除品牌名称
 */
export const removeBrandName = (productName: string) => {
  const brandName = ['影石Insta360', 'Insta360', 'insta360'];

  const res = brandName.reduce((prev, brand) => {
    const regExp = new RegExp(brand, 'g');
    return prev.replace(regExp, '');
  }, productName);

  return res.trim();
};
